(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const animBusy = U.animBusy;
  const artStyle = U.artStyle;
  const backSvg = U.backSvg;
  const beginDrag = U.beginDrag;
  const cardActions = U.cardActions;
  const cardTitle = U.cardTitle;
  const clickCard = U.clickCard;
  const closeInspector = U.closeInspector;
  const dispatch = U.dispatch;
  const el = U.el;
  const esc = U.esc;
  const groupMoveDests = U.groupMoveDests;
  const live = U.live;
  const markStates = U.markStates;
  const pcls = U.pcls;
  const poolToken = U.poolToken;
  const renderHandCard = U.renderHandCard;
  const setShowLog = U.setShowLog;
  const togglePick = U.togglePick;
  const viewPlayer = U.viewPlayer;

  const DOT_LIMIT = 12;

  function damageTrack(assigned, lethal, marks, total) {
    const track = el("div", "adots");
    if (marks + Math.max(lethal, total) > DOT_LIMIT) {
      track.classList.add("num");
      track.appendChild(el("span", null, assigned + " / " + lethal));
      return track;
    }
    for (let i = 0; i < marks; i++) track.appendChild(el("span", "adot old"));
    if (marks) track.appendChild(el("span", "asplit"));
    for (let i = 0; i < lethal; i++) {
      track.appendChild(el("span", "adot" + (i < assigned ? " hit" : "")));
    }
    for (let i = lethal; i < assigned; i++) track.appendChild(el("span", "adot over"));
    return track;
  }

  function stepButton(glyph, enabled, onClick) {
    const b = el("button", "astep", glyph);
    if (enabled) b.onclick = onClick;
    else b.disabled = true;
    return b;
  }

  function renderSplit(state, pd) {
    const wrap = el("div", "assign split");
    const sp = pd.split;
    const placed = sp.total - sp.left;
    const head = el("div", "ahead");
    head.appendChild(el("h3", null, esc(state.players[pd.player].name) + " — " + sp.total + " damage to split"));
    const strip = el("div", "apool");
    if (sp.total <= DOT_LIMIT) {
      for (let i = 0; i < sp.total; i++) strip.appendChild(el("span", "atok" + (i < placed ? " spent" : "")));
    }
    strip.appendChild(el("span", "acount" + (sp.left ? "" : " full"), placed + " / " + sp.total));
    head.appendChild(strip);
    wrap.appendChild(head);
    for (const iid of pd.cands) {
      (function (iid) {
        const dealt = sp.deals[iid] || 0;
        const might = Core.effMight(state, iid);
        const lethal = might === null || might === undefined ? 0 : Math.max(0, might - Core.totalDamage(state.objs[iid] || {}));
        const row = el("div", "arow" + (dealt >= lethal && lethal ? " done" : dealt ? " part" : ""));
        const art = el("div", "asp");
        artStyle(art, state, iid);
        art.title = cardTitle(state, iid);
        art.onclick = function (ev) { clickCard(iid, ev); };
        if (might !== null && might !== undefined) art.appendChild(el("span", "mv", String(might)));
        row.appendChild(art);
        const name = el("div", "anm");
        name.appendChild(el("span", "n", esc(Core.name(state, iid))));
        row.appendChild(name);
        row.appendChild(damageTrack(dealt, lethal, Core.totalDamage(state.objs[iid] || {}), sp.total));
        row.appendChild(el("span", "aval", String(dealt)));
        row.appendChild(stepButton("+", sp.left > 0, function () {
          dispatch({ type: "CHOOSE", player: pd.player, picks: [iid] });
        }));
        wrap.appendChild(row);
      })(iid);
    }
    wrap.appendChild(el("div", "aerr", sp.left + " left — each + deals 1 to that unit; the damage lands once all of it is placed."));
    return wrap;
  }

  function nameHits(pd, query) {
    const all = window.RB.FX.nameUniverse(pd.nameKind || "tag", pd.nameType || null);
    const q = (query || "").trim().toLowerCase();
    if (!q) return all;
    const starts = [], within = [];
    for (const n of all) {
      const at = n.toLowerCase().indexOf(q);
      if (at === 0) starts.push(n); else if (at > 0) within.push(n);
    }
    return starts.concat(within);
  }

  function renderNameInput(state, pd) {
    const wrap = el("div", "namebox");
    const known = pd.options || [];
    const what = pd.nameKind === "card" ? (pd.nameType ? pd.nameType + " name" : "card name") : "tag";
    const input = el("input", "nameinput");
    input.type = "text";
    input.placeholder = "Type a " + what + "…";
    input.value = APP.nameQuery || "";
    input.setAttribute("autocomplete", "off");
    const list = el("div", "namelist");
    const submit = function (name) {
      APP.nameQuery = "";
      dispatch({ type: "CHOOSE", player: pd.player, name: name });
    };
    const refresh = function () {
      list.innerHTML = "";
      const hits = nameHits(pd, input.value);
      const shown = hits.slice(0, NAME_LIMIT);
      for (const n of shown) {
        (function (n) {
          const b = el("button", "btn namehit" + (known.indexOf(n) >= 0 ? " known" : ""), esc(n));
          if (known.indexOf(n) >= 0) b.title = "In this game";
          b.onclick = function (ev) { if (ev && ev.stopPropagation) ev.stopPropagation(); submit(n); };
          list.appendChild(b);
        })(n);
      }
      if (hits.length > shown.length) list.appendChild(el("span", "note", (hits.length - shown.length) + " more — keep typing"));
      if (!hits.length) list.appendChild(el("span", "note bad", "No " + what + " matches that. Only something that exists can be named."));
    };
    input.oninput = function () { APP.nameQuery = input.value; refresh(); };
    input.onkeydown = function (ev) {
      if (ev.key !== "Enter") return;
      const hits = nameHits(pd, input.value);
      const q = (input.value || "").trim().toLowerCase();
      const exact = hits.find(function (n) { return n.toLowerCase() === q; });
      if (exact) submit(exact); else if (hits.length === 1) submit(hits[0]);
    };
    input.onclick = function (ev) { if (ev && ev.stopPropagation) ev.stopPropagation(); };
    wrap.appendChild(input);
    wrap.appendChild(list);
    refresh();
    if (live() && !animBusy()) setTimeout(function () { if (input.focus) input.focus(); }, 0);
    return wrap;
  }
  const NAME_LIMIT = 12;

  function renderAssign(state, pd, actions) {
    const Enum = window.RB.Enum;
    const wrap = el("div", "assign");
    const lim = Enum.assignLimits(state, pd, APP.assign);
    const pool = lim.$;

    const setTo = function (iid, v) {
      const bounded = Math.max(lim[iid].min, Math.min(lim[iid].max, v));
      APP.assign[iid] = bounded;
      U.render();
    };

    const head = el("div", "ahead");
    head.appendChild(el("h3", null, esc(state.players[pd.player].name) + " — " + pd.total + " damage"));
    const strip = el("div", "apool");
    if (pd.total <= DOT_LIMIT) {
      for (let i = 0; i < pd.total; i++) {
        strip.appendChild(el("span", "atok" + (i < pool.placed ? " spent" : "")));
      }
    }
    strip.appendChild(el("span", "acount" + (pool.remaining ? "" : " full"), pool.placed + " / " + pd.total));
    head.appendChild(strip);
    wrap.appendChild(head);

    for (const iid of pd.targets) {
      (function (iid) {
        const info = lim[iid];
        const cls = ["arow"];
        if (info.gate) cls.push("locked");
        else if (info.rank === 0) cls.push("tank");
        if (info.value >= info.lethal && !info.gate) cls.push("done");
        else if (info.value > 0) cls.push("part");
        const row = el("div", cls.join(" "));

        row.appendChild(stepButton("«", info.value > info.min, function () { setTo(iid, info.min); }));
        row.appendChild(stepButton("−", info.value > info.min, function () { setTo(iid, info.value - 1); }));

        const sp = el("div", "asp");
        artStyle(sp, state, iid);
        sp.title = cardTitle(state, iid);
        sp.onclick = function (ev) { clickCard(iid, ev); };
        sp.appendChild(el("span", "mv", String(Core.effMight(state, iid))));
        row.appendChild(sp);

        const name = el("div", "anm");
        name.appendChild(el("span", "n", esc(Core.name(state, iid))));
        if (info.rank === 0) name.appendChild(el("span", "tag tank", "TANK"));
        if (info.rank === 2) name.appendChild(el("span", "tag back", "BACKLINE"));
        row.appendChild(name);

        row.appendChild(damageTrack(info.value, info.lethal, info.marks, pd.total));

        if (info.gate) {
          const lock = el("span", "alock",
            "<svg width='15' height='15' viewBox='0 0 16 16' fill='none' stroke='currentColor' stroke-width='1.6'>" +
            "<rect x='2.8' y='7' width='10.4' height='7' rx='1.4'></rect>" +
            "<path d='M5.2 7V4.8a2.8 2.8 0 0 1 5.6 0V7'></path></svg>");
          lock.title = info.gate === "tank"
            ? "Tank units must be assigned lethal damage first."
            : "Backline units must be assigned damage last.";
          row.appendChild(lock);
        } else {
          row.appendChild(el("span", "aval", String(info.value)));
        }

        row.appendChild(stepButton("+", info.value < info.max, function () { setTo(iid, info.value + 1); }));
        row.appendChild(stepButton("»", info.value < info.max, function () { setTo(iid, info.max); }));
        wrap.appendChild(row);
      })(iid);
    }

    const problem = Enum.assignProblem(state, pd, APP.assign);
    wrap.appendChild(el("div", "aerr", problem && !pool.remaining ? U.fmtText(problem) : ""));

    const ok = el("button", "btn primary", "Deal damage");
    if (problem) {
      ok.disabled = true;
      ok.title = problem;
    } else {
      ok.onclick = function () { dispatch({ type: "ASSIGN", player: pd.player, dist: Object.assign({}, APP.assign) }); };
    }
    actions.appendChild(ok);
    return wrap;
  }

  function renderPrompt(state) {
    const div = el("div");
    div.id = "promptbar";
    const pd = state.pending;

    if (APP.error) div.appendChild(el("span", "error", "⚠ " + U.fmtText(APP.error)));

    if (state.over) {
      div.appendChild(el("span", "gameover", esc(state.players[state.over.winner].name).toUpperCase() + " WINS THE GAME"));
      return div;
    }
    if (!live()) {
      div.appendChild(el("h3", null, "Replay view"));
      div.appendChild(el("span", "note", "Viewing action " + APP.viewIndex + " of " + APP.game.log.length + " — scrub the timeline, or continue from here to branch."));
      return div;
    }
    if (!pd) {
      div.appendChild(el("h3", null, "…"));
      return div;
    }

    if (animBusy()) {
      div.appendChild(el("h3", null, "Resolving…"));
      div.appendChild(el("span", "note", "Effects are playing out on the board."));
      return div;
    }

    const pname = pd.player !== undefined ? state.players[pd.player].name : "";
    const actions = el("div", "actions");

    const busyNote = function () {
      return pd.kind === "mulligan" ? "Deciding the mulligan." :
        pd.kind === "act" ? "Choosing a move." :
        pd.kind === "focus" || pd.kind === "respond" ? "Deciding whether to respond." :
        pd.kind === "pay" ? "Paying a cost." :
        pd.kind === "assign" ? "Assigning combat damage." :
        "Resolving a decision (" + pd.kind + ").";
    };

    if (pd.player !== undefined && APP.ai[pd.player]) {
      const strength = U.nativeStrength(pd.player);
      if (strength) {
        div.appendChild(el("h3", null, esc(pname) + " (Native, " + esc(strength) + ") is thinking…"));
        div.appendChild(el("span", "note", esc(APP.nativeNote || (busyNote() + (APP.nativePending ? " Searching on the server…" : "")))));
        return div;
      }
      div.appendChild(el("h3", null, esc(pname) + " (AI) is thinking…"));
      div.appendChild(el("span", "note", esc(busyNote())));
      return div;
    }

    if (APP.net && pd.player !== APP.seat) {
      div.appendChild(el("h3", null, esc(pname) + " is deciding…"));
      div.appendChild(el("span", "note", esc(busyNote() + " Their hand and deck stay on the server.")));
      return div;
    }

    if (pd.kind === "act") {
      div.appendChild(el("h3", null, esc(pname) + " — Your move"));
      div.appendChild(el("span", "note", U.fmtText("Click a card for its actions, or drag it onto the table.")));
      const endBtn = el("button", "btn primary", "End Turn");
      endBtn.onclick = function () { dispatch({ type: "END_TURN", player: pd.player }); };
      actions.appendChild(endBtn);
    }

    if (pd.kind === "focus" || pd.kind === "respond") {
      div.appendChild(el("h3", null, esc(pname) + " — " + (pd.kind === "focus" ? "Showdown" : "Respond")));
      let winNote = "Play a lit card, or pass.";
      const fdReady = U.LEGAL && state.battlefields.some(function (b) {
        return RB.Flow.hiddenAt(state, b).some(function (fd) {
          return state.objs[fd].owner === pd.player && !!U.LEGAL.play[fd];
        });
      });
      if (fdReady) winNote += " Your hidden card is glowing — click it to reveal and play it for free.";
      div.appendChild(el("span", "note", winNote));
      const pass = el("button", "btn primary", "Pass");
      pass.onclick = function () { dispatch({ type: "PASS", player: pd.player }); };
      actions.appendChild(pass);
    }

    if (pd.kind === "mulligan") {
      div.appendChild(el("h3", null, esc(pname) + " — Mulligan"));
      div.appendChild(el("span", "note", "Click up to 2 hand cards to recycle (" + APP.picked.length + " selected), then confirm."));
      const btn = el("button", "btn primary", "Confirm mulligan (" + APP.picked.length + ")");
      btn.onclick = function () { dispatch({ type: "MULLIGAN", player: pd.player, cards: APP.picked.slice() }); };
      actions.appendChild(btn);
    }

    if (pd.kind === "choose" && pd.tag === "orderTriggers" && pd.options) {
      if (APP.trigAutoPd === pd) {
        div.appendChild(el("h3", null, esc(pname) + " — Building the chain…"));
        return div;
      }
      div.appendChild(el("h3", null, esc(pname) + " — Order your triggers"));
      div.appendChild(el("span", "note",
        "These triggered at the same time (rule 383.3.d). Number them in the floating window: " +
        "1 is placed first and resolves LAST — the highest number resolves FIRST."));
      return div;
    }

    if (pd.kind === "choose" && pd.tag === "predict" && pd.options) {
      div.appendChild(el("h3", null, esc(pname) + " — Vision"));
      const reveal = el("div", "predictreveal");
      const top = state.players[pd.player].mainDeck[0];
      const c = top ? Core.card(state, top) : null;
      if (c) {
        const img = document.createElement("img");
        RB.artSrc(img, c, "140px");
        RB.artFallback(img, c);
        reveal.appendChild(img);
      }
      const col = el("div", "pcol");
      col.appendChild(el("div", "pname", esc(c ? c.name : "Top card")));
      if (c && c.text) col.appendChild(el("div", "ptext", U.fmtText(c.text)));
      col.appendChild(el("div", "note", "This is the top card of your deck. Keep it there, or recycle it away."));
      const row = el("div", "actions");
      const keep = el("button", "btn primary", U.fmtText(pd.options[1] || "Keep on top"));
      keep.onclick = function () { dispatch({ type: "CHOOSE", player: pd.player, optionIdx: 1 }); };
      row.appendChild(keep);
      const rec = el("button", "btn", U.fmtText(pd.options[0] || "Recycle"));
      rec.onclick = function () { dispatch({ type: "CHOOSE", player: pd.player, optionIdx: 0 }); };
      row.appendChild(rec);
      col.appendChild(row);
      reveal.appendChild(col);
      div.appendChild(reveal);
      return div;
    }

    if (pd.kind === "choose") {
      if (pd.src) {
        div.appendChild(el("h3", null, esc(pname) + " — " + U.fmtText(pd.src)));
        const stepTxt = pd.step ? "Step " + pd.step.n + " of " + pd.step.of + ": " : "";
        div.appendChild(el("span", "fxprompt", U.fmtText(stepTxt + (pd.prompt || "Choose"))));
      } else {
        div.appendChild(el("h3", null, esc(pname) + " — " + U.fmtText(pd.prompt || "Choose")));
      }
      if (pd.hint) div.appendChild(el("span", "note", U.fmtText(pd.hint)));
      if (pd.tag === "name") {
        div.appendChild(renderNameInput(state, pd));
      } else if (pd.split) {
        div.appendChild(renderSplit(state, pd));
      } else if (pd.options) {
        for (let i = 0; i < pd.options.length; i++) {
          (function (i) {
            const b = el("button", "btn " + (i === 0 ? "primary" : ""), U.fmtText(pd.options[i]));
            b.onclick = function () { dispatch({ type: "CHOOSE", player: pd.player, optionIdx: i }); };
            actions.appendChild(b);
          })(i);
        }
      } else if (pd.locChoices) {
        div.appendChild(el("span", "note", "Click a highlighted location."));
      } else {
        div.appendChild(el("span", "note", APP.picked.length + " / " + (pd.max || 1) + " picked (need " + (pd.min !== undefined ? pd.min : 1) + "+). Click highlighted cards."));
        for (const b of U.confirmButtons(pd)) actions.appendChild(b);
      }
      if (pd.cancellable) actions.appendChild(U.cancelButton(pd));
    }

    if (pd.kind === "pay") {
      const auto = U.autoPayable(state);
      if (auto) div.appendChild(U.renderAutoPaying(state, pd, auto));
      else div.appendChild(U.renderPay(state, pd));
    }

    if (pd.kind === "assign") {
      div.appendChild(renderAssign(state, pd, actions));
    }

    if (pd.kind === "manual") {
      div.appendChild(el("h3", null, esc(pname) + " — Manual: " + U.fmtText(pd.label || "")));
      div.appendChild(el("span", "note", U.fmtText(pd.note || "") + "\nApply the effect with the manual palette, then continue."));
      if (!APP.showManual) {
        const openPal = el("button", "btn", "Open manual palette");
        openPal.onclick = function () { U.setShowManual(true); };
        actions.appendChild(openPal);
      }
      const cont = el("button", "btn primary", "Done - continue");
      cont.onclick = function () { dispatch({ type: "CONTINUE", player: pd.player }); };
      actions.appendChild(cont);
    }

    if (actions.children.length) div.appendChild(actions);
    return div;
  }

  Object.assign(U, { renderPrompt: renderPrompt, renderNameInput: renderNameInput, renderAssign: renderAssign, renderSplit: renderSplit });
})();
